import { Component, OnInit, Inject } from "@angular/core"
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog"
import { IconImageService } from "@shared/services/icon-image.service"

@Component({
  selector: "ag-confirm-dialog",
  templateUrl: "./ag-confirm-dialog.component.html",
  styleUrls: ["./ag-confirm-dialog.component.scss"],
  standalone: false,
})
export class AgConfirmDialogComponent implements OnInit {
  public dialogTitle: string
  public dialogDescription: string
  public dialogDescriptionHTML: string = ""
  public destructive: boolean
  public destructiveText: string = "Delete"
  public buttonText: string
  public secondaryButtonText: string
  public padding: string = ""
  public secondaryDescription: string
  public crossIcon: boolean = false
  public hideSecondaryButton: boolean = false
  public hidePrimaryButton: boolean = false

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AgConfirmDialogComponent>,
    public iconService: IconImageService,
  ) {}

  ngOnInit(): void {
    this.dialogRef.addPanelClass("ag-confirm-dialog-panel")
    this.dialogTitle = this.data.dialogTitle
    this.dialogDescription = this.data.dialogDescription
    this.dialogDescriptionHTML = this.data.dialogDescriptionHTML
    this.buttonText = this.data.buttonText
    this.secondaryButtonText = this.data.secondaryButtonText
    this.padding = this.data.padding ?? "24px"
    this.secondaryDescription = this.data.secondaryDescription
    this.crossIcon = this.data.crossIcon ?? false
    this.hideSecondaryButton = this.data.hideSecondaryButton ?? false
    this.hidePrimaryButton = this.data.hidePrimaryButton ?? false
    this.destructiveText = this.data.destructiveText ?? "Delete"
    if (!this.buttonText) {
      this.buttonText = "Confirm"
    }
    if (!this.secondaryButtonText) {
      this.secondaryButtonText = "Cancel"
    }
    this.destructive = this.data.destructive
    if (!this.destructive) {
      this.destructive = false
    }
  }

  submitQuickAction() {
    this.dialogRef.close(true)
  }

  closeDialog() {
    this.dialogRef.close(false)
  }
}
